import classes from "./styles.module.scss";
import clsx from "classnames";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { AccordionItem, Description, Title } from "@/ui";

export const Accordion = ({ className, title, description, items, defaultActiveKey }) => {
  const [active, setActive] = useState(defaultActiveKey);

  return (
    <div className={clsx(className, classes.accordion)}>
      <Container className="mw-lg">
        <Title title={title} data-sourceflow-prop="title" />
        <Description className="mb-4" description={description} data-sourceflow-prop="description" />
        {items.map(({ title, body }, k) => (
          <AccordionItem
            key={k}
            eventKey={k}
            title={title}
            body={body}
            active={k === active}
            onClick={() => setActive(k === active ? null : k)}
            data-sourceflow-prop="items"
          />
        ))}
      </Container>
    </div>
  );
};

export default Accordion;
